import React from "react";
import ReactDOM from "react-dom";

import App from "./App";
import GlobalStyle from "./style/Global";
import ContextProvider from "./Provider";

ReactDOM.render(
  <ContextProvider>
    <GlobalStyle />
    <App />
  </ContextProvider>,
  document.getElementById("root")
);
